module.exports = __webpack_public_path__ + "img/xuxuefeng.0df11ea8.png";